import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'

import { catchError, switchMap, map } from 'rxjs/operators'
import { of } from 'rxjs'

import * as TrackSaleActions from '../actions/track-sale.actions'
import { TrackSaleService } from 'src/app/services/track-sale.service'
import { refreshData } from '../actions/criteria.actions'

@Injectable()
export class TrackSaleEffects {
  constructor(private actions$: Actions, private trackSaleService: TrackSaleService) {}

  loadTrackSales$ = createEffect(() =>
    this.actions$.pipe(
      ofType(refreshData),
      switchMap(action =>
        this.trackSaleService.findTrackSales(action.artistId, action.from, action.to).pipe(
          map(sales => TrackSaleActions.loadTrackSalesSuccess({ sales })),
          catchError(error => of(TrackSaleActions.loadTrackSalesFailure({ error })))
        )
      )
    )
  )
}
